import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../../ricos-context";
import { getIsModalOpen, useModalState } from "./../../../ricos-modals/modal-service-provider";
import { DropdownButton } from "../../components";
import { sizeIconMap } from "./consts";
const NodeSizeButton = ({ toolbarItem, dataHook, id }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalServiceContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(id));
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedSize = () => toolbarItem?.attributes.nodeSize || "CONTENT";
  const selectedSize = getSelectedSize();
  const SelectedSizeIcon = sizeIconMap[`${selectedSize}`];
  const closeModal = () => modalService.closeModal(id);
  const onSizeClick = (size) => {
    toolbarItem.commands?.setSize({ value: size });
    closeModal();
  };
  const onClick = () => {
    modalService.isModalOpen(id) ? closeModal() : modalService?.openRegisteredModal(id, {
      componentProps: {
        getSelectedSize,
        onClick: onSizeClick
      },
      layout: isMobile ? "drawer" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick,
      setRef: setReferenceElement,
      Icon: SelectedSizeIcon,
      tooltip: t("ButtonModal_Size_Section")
    }
  );
};
var NodeSizeButton_default = NodeSizeButton;
export {
  NodeSizeButton_default as default
};
//# sourceMappingURL=NodeSizeButton.js.map
